import { createReducer } from '@reduxjs/toolkit';
import { records as appStorageRecords } from '@saucelabs/sl-module-app-storage';

import actions from './actions';

type MobileAppSelectionState = {
  readonly files: appStorageRecords.AppStorageFile[];
  readonly isLoadingFiles: boolean;
  readonly moreFilesAvailable: boolean;
}

const initialState: MobileAppSelectionState = {
  files: [],
  isLoadingFiles: false,
  moreFilesAvailable: false,
};

const mobileAppSelectionReducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.fetchAppStorageFiles.pending, (draft) => {
    draft.isLoadingFiles = true;
  });

  builder.addCase(actions.fetchAppStorageFiles.fulfilled, (draft, { payload }) => {
    draft.files = payload.items;
    draft.isLoadingFiles = false;
    draft.moreFilesAvailable = !!payload.links.next;
  });

  builder.addCase(actions.fetchAppStorageFiles.rejected, (draft) => {
    draft.files = [];
    draft.isLoadingFiles = false;
    draft.moreFilesAvailable = false;
  });
});

export default mobileAppSelectionReducer;
export {
  initialState,
  MobileAppSelectionState,
};
